import type { LinkTarget } from "@/components/link";

/**
 * A link into another page that carries the visitor's context (filters, search).
 * Crawlers, new tabs and shared links get the destination's canonical URL; a click
 * lands on the filtered view. The mask is dropped on reload so the client matches
 * what SSR rendered for the plain URL.
 */
export function handoffLinkTarget({ to, params, search }: Omit<LinkTarget, "mask">): LinkTarget {
  const context = Object.fromEntries(
    Object.entries(search ?? {}).filter(([, value]) => value !== undefined),
  );
  if (Object.keys(context).length === 0) return { to, params };
  return { to, params, search: context, mask: { to, params, unmaskOnReload: true } };
}
